/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormDateField, {
  FormDateFieldProps
} from '../../../../client/js/components/form/fields/FormDateField'

function BirthDateField (props: FormDateFieldProps) {
  const { name = 'birthDate', ...others } = props
  const intl = useIntl()
  return (
    <FormDateField
      label={intl.formatMessage({
        id: 'birth_date',
        defaultMessage: 'Date de naissance'
      })}
      name={name}
      {...others}
    />
  )
}

export default BirthDateField
